
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class ScaffoldHeader extends Vue {
    @Prop({ type: String, default: "" }) readonly title!: string;

    get isIconSlotUsed(): boolean {
      return Boolean(this.$slots.icon);
    }
  }
